<template>
	<div class="pa-3">
		<v-breadcrumbs :items="breadcrumbs" divider="&gt;"></v-breadcrumbs>

		<v-data-table :headers="headers" :items="data.items" :hide-actions="true" :loading="loading">
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
			<template slot="items" slot-scope="props">
				<td class="text-xs-center">{{ props.item.startDate }}</td>
				<td>{{ props.item.headline }}</td>
				<td>{{ stripTags(props.item.text) | truncate(100) }}</span></td>
				<td class="justify-center text-xs-center pa-0">
					<v-btn small flat icon @click="handleEdit(props.item)"><v-icon small>edit</v-icon></v-btn>
					<v-btn small flat icon @click="handleDelete(props.item)"><v-icon small>delete</v-icon></v-btn>
				</td>
			</template>
			<template slot="no-data">
				<v-btn color="primary" @click="handlePageChange(1)">Reset</v-btn>
			</template>
		</v-data-table>

	    <div class="pt-2 pb-5">
			<v-pagination v-model="data.page" :length="pages" :total-visible="6"></v-pagination>
	    </div>

		<v-btn fixed dark fab bottom right color="primary" @click="handleAdd">
			<v-icon>add</v-icon>
        </v-btn>

		<v-dialog v-model="toggle.dialog" scrollable max-width="690px">
		    <v-card>
		        <v-card-title class="headline grey lighten-2" primary-title>
		            {{ formTitle }}
		        </v-card-title>
		        <v-card-text>
		            <v-container grid-list-md>
		            	<v-form ref="form" v-model="valid" class="pb-5" lazy-validation>
			                <v-layout wrap>
			                    <v-flex xs12>
									<v-menu :close-on-content-click="false" v-model="toggle.startDate" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
									    <v-text-field slot="activator" v-model="item.startDate" label="Date" prepend-icon="event" readonly></v-text-field>
									    <v-date-picker v-model="item.startDate" @input="toggle.startDate = false"></v-date-picker>
									</v-menu>
			                    </v-flex>
			                    <v-flex xs12>
			                        <v-text-field v-model="item.headline" label="Headline" required></v-text-field>
			                    </v-flex>
			                    <v-flex xs12>
			                    	<label for="content-text">Text</label>
			                        <content-text v-model="item.text"></content-text>
			                    </v-flex>
			                    <v-flex xs12>
									<image-upload v-model="item.asset_media"></image-upload>
									<v-img v-if="item.asset_media" :src="item.asset_media" class="grey lighten-2 elevation-1"></v-img>
			                    </v-flex>
			                </v-layout>
			            </v-form>
		            </v-container>
		        </v-card-text>
				<v-divider></v-divider>
		        <v-card-actions>
		            <v-spacer></v-spacer>
		            <v-btn color="blue darken-1" flat @click="toggle.dialog = false">Cancel</v-btn>
		            <v-btn color="blue darken-1" flat :loading="saving" @click="handleSave">Save</v-btn>
		        </v-card-actions>
		    </v-card>
		</v-dialog>
	</div>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

	import ContentText from '@/components/ContentText.vue'
	import ImageUpload from '@/components/ImageUpload.vue'

	export default {
		filters: {
			truncate: (text, stop, clamp) => {
				return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
			}
		},
		components: {
			ContentText,
			ImageUpload
		},
		data () {
			return {
	        	apiUrl: `${config.BASE_URL}/museum-of-us`,
				breadcrumbs: [
					{
						text: 'Home',
						disabled: false,
						href: config.PUBLIC_PATH
					},
					{
						text: 'Jeban Timeline',
						disabled: true,
						href: config.PUBLIC_PATH + 'timeline'
					}					
				],
				headers: [
					{
						text: 'Date',
						align: 'center',
						sortable: false,
						width: '120',
					},
					{
						text: 'Headline',
						sortable: false,
						width: '250',
					},
					{
						text: 'Text',
						sortable: false,
					},
					{ 
						align: 'center', 
						sortable: false,
						width: '150'
					}
				],
	            data: {
	                page: 1,
	                totalRecords: 0,
	                items: []
	            },
				pageSize: 10,
				valid: true,
				loading: true,
				saving: false,
				formTitle: 'New Event',
				item: {
					id: null,
					startDate: new Date().toISOString().substring(0, 10),
					headline: '',
					text: '',
					asset_media: '',
					asset_caption: '',
					asset_credit: '',
				},
				toggle: {
					dialog: false,
					startDate: false
				}
			}
		},
		computed: {
			pages () {
				if (this.pageSize == null || this.data.totalRecords == null) {
					return 0
				}
				return Math.ceil(this.data.totalRecords / this.pageSize)
			}
		},
		created () {
			this.handlePageChange(1)
		},
		methods: {
			stripTags (html)
			{
				var div = document.createElement("div")
				div.innerHTML = html

				return div.textContent || div.innerText || ""
			},
			resetItemOnDialog () 
			{
				return new 
					Promise((resolve) => {
						this.item = {
							id: null,
							startDate: new Date().toISOString().substring(0, 10),
							headline: '',
							text: '',
							asset_media: '',
							asset_caption: '',
							asset_credit: '',
						}
						resolve(true)
					})
			},
	    	handlePreview (itemRow)
	    	{
	    		// window.open('https://www.jeban.com/spotlight/' + itemRow.slug, itemRow.slug)
	    	},
	    	handleAdd ()
	    	{
	    		this.resetItemOnDialog()
	    			.then(() => {
	    				this.formTitle = 'New Event'
	    				this.toggle.dialog = true
	    			})
	    	},
	    	handleEdit (itemRow)
	    	{
				axios.get(this.apiUrl + '/' + itemRow.id)
					.then((response) => {
						this.item = response.data
						this.formTitle = 'Edit Event'
						this.toggle.dialog = true
					})
	    	},
	        handleDelete(itemRow)
	        {
	        	if (confirm('Remove "' + itemRow.headline + '" ?')) {
		    		axios.delete(this.apiUrl + '/' + itemRow.id)
			    		.then((response) => {
			    			this.handlePageChange(this.data.items.page)
			    		}).catch((error) => {
			    			this.$store.commit(types.SET_ERROR_MSG, error)
						})
	        	}
	        },
	        handlePageChange(pageNum)
	        {
	            var apiUrl = this.apiUrl;

            	apiUrl += '?order=startDate,desc&limit=' + this.pageSize
	            if (parseInt(pageNum, 10) > 1) {
	                apiUrl += '&page=' + parseInt(pageNum, 10)
	            }

	            this.loading = true

	            axios.get(apiUrl)
	                .then((response) => {
	                	this.data.page = response.data.current_page
	                    this.data.totalRecords = response.data.total
	                    this.data.items = response.data.data

	                    this.loading = false
	                });
	        },
	        handleSave ()
	        {
		    	if (this.$refs.form.validate()) {
		    		if ((!this.item.startDate)) {
		    			this.$store.commit(types.SET_ERROR_MSG, "No date select.")
		    			return false;
		    		}
		    		if ((!this.item.headline)) {
		    			this.$store.commit(types.SET_ERROR_MSG, "No headline.")
		    			return false;
		    		}
		    		if ((!this.item.text)) {
		    			this.$store.commit(types.SET_ERROR_MSG, "No text.")
		    			return false;
		    		}
		    		if ((!this.item.asset_media)) {
		    			this.$store.commit(types.SET_ERROR_MSG, "No media.")
		    			return false;
		    		}

			    	if (this.item.id) {
				    	axios.put(this.apiUrl + '/' + this.item.id, this.item)
				    		.then((response) => {
			    				this.handlePageChange(this.data.page)
			    				this.toggle.dialog =false
				    		}).catch((error) => {
			    				this.$store.commit(types.SET_ERROR_MSG, error)
							});
			    	} else {
				    	axios.post(this.apiUrl, this.item)
				    		.then((response) => {
			    				this.handlePageChange(1)
			    				this.toggle.dialog =false
				    		}).catch((error) => {
			    				this.$store.commit(types.SET_ERROR_MSG, error)
							});
			    	}
			    }
	        },
		},
		watch: {
			'data.page' (to, from) {
				if (to !== from) {
					this.handlePageChange(to)
				}
			}
		}
	}
</script>

<style lang="scss">
	label[for="content-text"] {
		color: rgba(0,0,0,.54);
	}
</style>